export default function Info() {
  return (
    <div className="container mt-5">
      <div className="card bg-dark text-white shadow p-5 text-center">

        <h2 className="mb-4">Contact us</h2>

        <p>
            <strong>Phone:</strong>{" "}
        <a href="tel:+381638597131">+381 63 859 7131</a>
        </p>

        <p>
            <strong>Email:</strong>{" "}
        <a href="mailto:info@alphapremiumsolutions.com">
            info@alphapremiumsolutions.com
        </a>
        </p>

        <hr className="bg-light" />

        <p className="mt-4 fw-bold text-uppercase">
          Alpha Solutions - Support
        </p>

      </div>
    </div>
  );
}